export default __webpack_public_path__ + "static/hello-c6f892c7521eb92ce1cb67709e358c95.png";